import { Getter, Fold } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
export const _NextVideosGetter = Getter.of();
export const _NextVideosResponseGetter = Getter.of();
export const _NextVideosResponse2Videos = Fold.mapF((res) => Res.map((x) => x.data, res));

